// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6DIG4","question":"styles_question__2AmpI","description":"styles_description__3q4ip"};